import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { AttorneyService } from "../../../../services/ClientService";

import { useCallback } from "react";
import { Checkbox } from "@material-ui/core";

export default function AttorneyProfile(
    this: any,
    {
        attorney,
        setShowModal,
    }: {
        attorney: APIModels.Attorney;
        setShowModal: (value: boolean) => void;
    }
) {
    const [updatedAttorney, setUpdatedAttorney] = useState(attorney);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedAttorney(attorney);
    }, [attorney]);

    const onSaveClick = useCallback(async () => {
        setSaving(true);
        AttorneyService.saveProfile({
            attorneyId: attorney.id!,
            body: updatedAttorney,
        }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    setErrorMessage(resp.errorMessage ?? "");
                    attorney = { ...resp.data };
                } else {
                    console.log(resp.errorMessage);
                }
            },
            (error) => {
                setSaving(false);
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
    }, [updatedAttorney]);

    return (
        <div className="card text-left">
            <div className="card-body">
                <h4 className="mb-3 bg-light p-2">Attorney Profile</h4>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtProfileFirstName"
                            className="form-label"
                        >
                            First Name
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtProfileFirstName"
                                placeholder="Firstname"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.firstName}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        firstName: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid first name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtProfileMiddleName"
                            className="form-label"
                        >
                            Middle Name
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtProfileMiddleName"
                                placeholder="Middle Name"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.middleName}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        middleName: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid middle name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtProfileLastName"
                            className="form-label"
                        >
                            Last Name
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtProfileLastName"
                                placeholder="Last Name"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.lastName}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        lastName: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid middle name.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtProfileFullName"
                            className="form-label"
                        >
                            Full Name
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtProfileFullName"
                                placeholder="Full Name"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.fullName}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        fullName: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid middle name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="txtState" className="form-label">
                            State
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtState"
                                placeholder="State"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.state}
                                maxLength={2}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        state: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid state.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="txtBarNumber" className="form-label">
                            Bar Number
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtBarNumber"
                                placeholder="BarNumber"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.barNumber}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        barNumber: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid bar number.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <label htmlFor="txtPhoneNumber" className="form-label">
                            Phone Number
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtPhoneNumber"
                                placeholder="(___) ___-____"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.phoneNumber}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        phoneNumber: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid bar number.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="txtEmailAddress" className="form-label">
                            Email Address
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtEmailAddress"
                                placeholder="email@address.com"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.emailAddress}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        emailAddress: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid email address.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="txtFailedEmail" className="form-label">
                            Failed Email
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtFailedEmail"
                                placeholder="Failed Email"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.failedEmail}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        failedEmail: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid email address.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtExistingCasePrice"
                            className="form-label"
                        >
                            Existing Case Price
                        </label>
                        <div className="input-group">
                            <input
                                type="number"
                                className="form-control"
                                id="txtExistingCasePrice"
                                placeholder="$"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.existingCasePrice}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        existingCasePrice:
                                            event.currentTarget.valueAsNumber,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid existing case price.
                            </div>
                        </div>
                    </div>
                    <div
                        className="col-sm-4"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtUseClientControlID"
                                placeholder="UseClientControlID"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                style={{
                                    marginRight: "10px",
                                }}
                                checked={
                                    updatedAttorney.useClientControlID ?? false
                                }
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        useClientControlID:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtUseClientControlID"
                                className="form-check-label"
                            >
                                Use Client Control ID
                            </label>
                        </div>
                    </div>
                    <div
                        className="col-sm-4"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtUseClientControlID"
                                placeholder="UseClientControlID"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={updatedAttorney.active!}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        active: event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtUseClientControlID"
                                className="form-check-label"
                            >
                                Active
                            </label>
                        </div>
                    </div>
                    <div className="text-end">
                        {saving ? (
                            <button
                                className="btn btn-success waves-effect waves-light mt-2"
                                type="button"
                                disabled={true}
                            >
                                <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Saving...
                            </button>
                        ) : (
                            <button
                                className="btn btn-success waves-effect waves-light mt-2"
                                type="submit"
                                onClick={onSaveClick}
                            >
                                <i className="mdi mdi-content-save me-1"></i>
                                Save
                            </button>
                        )}
                        <div>{errorMessage}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
